import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Categories from './components/Categories';
import Contact from './components/Contact';
import VisaProServices from './pages/VisaProServices';

function App() {
    const [currentPage, setCurrentPage] = useState(() => {
        const params = new URLSearchParams(window.location.search);
        return params.get('page') === 'visa-pro-services' ? 'visa-pro-services' : 'home';
    });

    useEffect(() => {
        window.heroBotConfig = {
            apiKey: 'hb_851934e8bd0e844a965555a4bf3776909d3ee0ddaed27316'
        };

        const script = document.createElement('script');
        script.src = 'https://unwitty-harmfully-marylynn.ngrok-free.dev/widget/embed.js';
        script.async = true;

        document.body.appendChild(script);
    }, []);

    const navigateTo = (page) => {
        setCurrentPage(page);
        const path = page === 'home' ? '/' : `/?page=${page}`;
        window.history.pushState({}, '', path);
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        const handlePopState = () => {
            const params = new URLSearchParams(window.location.search);
            setCurrentPage(params.get('page') === 'visa-pro-services' ? 'visa-pro-services' : 'home');
        };
        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, []);

    if (currentPage === 'visa-pro-services') {
        return <VisaProServices onBack={() => navigateTo('home')} />;
    }

    return (
        <div className="App">
            <Navbar />
            <Hero />
            <Categories onNavigate={navigateTo} />
            <Contact />
        </div>
    );
}

export default App;